import { Reveal, Chapter } from "@/components/portfolio/motion";

const TAG_GROUPS = [
  {
    num: "A",
    category: "Marketing & GTM",
    tags: [
      "Go-to-market strategy",
      "Product launches",
      "Positioning and messaging",
      "Community building",
      "Brand marketing",
      "Lifecycle and consumer growth",
      "Cross-functional leadership",
      "Player community building (Discord, X, Instagram, Reddit)",
    ],
    testId: "skills-group-marketing",
  },
  {
    num: "B",
    category: "AI & Building",
    tags: [
      "Vibe coding",
      "AI-native full-stack app development",
      "Prompt-based product design",
    ],
    testId: "skills-group-ai",
  },
  {
    num: "C",
    category: "Tools",
    tags: [
      "Claude",
      "Gamma",
      "Canva AI",
      "Lovable",
      "Emergent",
      "Notion",
      "Make",
      "Google Analytics",
      "Google AdWords",
    ],
    testId: "skills-group-tools",
  },
];

const CERTS = [
  "Strategic Marketing for Leaders, Leveraging AI for Growth (IIM, 2025)",
  "AI Powered Customer Success (Coursera, 2026)",
  "Google AdWords & Analytics (2018)",
];

const Group = ({ g, i }) => (
  <Reveal delay={i * 0.06}>
    <div data-testid={g.testId} className="py-8 border-t border-line">
      <div className="flex items-center gap-3 mb-5">
        <span className="font-mono text-xs text-accent">{g.num}</span>
        <h3 className="font-display text-lg font-bold text-ink">{g.category}</h3>
      </div>
      <div className="flex flex-wrap gap-2.5">
        {g.tags.map((t, ti) => (
          <span
            key={ti}
            className="inline-flex items-center rounded-full border border-line bg-surface px-4 py-2 text-sm text-ink-soft hover:border-accent hover:text-accent transition-colors"
          >
            {t}
          </span>
        ))}
      </div>
    </div>
  </Reveal>
);

export const Skills = () => (
  <section
    id="skills"
    data-testid="skills-section"
    className="scroll-mt-20 max-w-6xl mx-auto px-5 sm:px-8 py-20 sm:py-28 border-t border-line"
  >
    <Chapter num="05 / Skills & Tools" label="Skills & Tools" testId="skills-chapter" />
    <div>
      {TAG_GROUPS.map((g, i) => (
        <Group key={i} g={g} i={i} />
      ))}

      <Reveal delay={0.05}>
        <div data-testid="skills-group-certifications" className="py-8 border-t border-line">
          <div className="flex items-center gap-3 mb-5">
            <span className="font-mono text-xs text-accent">D</span>
            <h3 className="font-display text-lg font-bold text-ink">
              Certifications
            </h3>
          </div>
          <ul className="space-y-3">
            {CERTS.map((c, i) => (
              <li key={i} className="flex items-start gap-3 text-ink-soft">
                <span className="mt-2 w-1.5 h-1.5 rounded-full bg-accent shrink-0" />
                <span>{c}</span>
              </li>
            ))}
          </ul>
          <p
            data-testid="skills-education"
            className="mt-6 text-sm text-muted border-l-2 border-accent/40 pl-4"
          >
            BBA, Marketing &amp; Entrepreneurship, Chapman University
          </p>
        </div>
      </Reveal>
    </div>
  </section>
);
